import { DatePicker, FormCard, FormItem, theme, TimeInput } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'
import { getRequiredRule } from '../utils'
import { ModalSectionProps } from '../RotaPattern/utils'
import styled from 'styled-components'
import { Tooltip } from 'antd'
import Asterix from '../RotaPattern/components/Asterix'

type OneOffTimeWindowProps = {
  type?: 'visit' | 'shift'
  isFlexiType?: boolean
  shortTitle?: boolean
  onStartTimeChanged?: (time?: string) => void
  onEndTimeChanged?: (time?: string) => void
  disableStartTime?: boolean
  disableEndTime?: boolean
} & ModalSectionProps

const OneOffTimeWindow: FC<OneOffTimeWindowProps> = ({
  type,
  shortTitle,
  onEndTimeChanged,
  onStartTimeChanged,
  disableStartTime,
  disableEndTime,
  formData,
}) => {
  const { t } = useTranslation()

  return (
    <FormCard
      level={2}
      title={
        shortTitle
          ? t('DATE_AND_TIME')
          : t('WHEN_SHOULD_THIS', { variable: type })
      }
      subtitle={
        shortTitle
          ? undefined
          : t('WHEN_SHOULD_THIS_DESCRIPTION', { variable: type })
      }
    >
      <Tooltip
        color={theme.color.neutral.color3}
        title={
          disableStartTime || disableEndTime ? (
            <ContentContainer>
              <Text>{t('DETAIL_CANNOT_BE_EDITED')}</Text>
            </ContentContainer>
          ) : (
            ''
          )
        }
        open={disableStartTime || disableEndTime ? undefined : false}
        overlayInnerStyle={{ width: '450px', padding: '8px 16px' }}
      >
        <FormItem
          name="patternStart"
          label={<Text>{t('DATE')}</Text>}
          rules={[getRequiredRule(t('DATE'))]}
        >
          <DatePicker disabled={disableStartTime || disableEndTime} />
        </FormItem>
      </Tooltip>
      <FormItem
        label={
          <Text>
            {' '}
            <Asterix />
            {t('TIME_WINDOW')}
          </Text>
        }
      >
        <TimeInput
          startTime={formData?.startTime}
          onEndTimeChanged={onEndTimeChanged}
          onStartTimeChanged={onStartTimeChanged}
          disableStartTime={disableStartTime}
          disableEndTime={disableEndTime}
        />
      </FormItem>
    </FormCard>
  )
}

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${(props) => props.theme.color.neutral.color11};
`

export default OneOffTimeWindow
